(() => {
  function init(root = document) {
    root.querySelectorAll('[data-pr-cart-count]').forEach(el => { el.dataset.empty = String(!Number(el.textContent)); });
  }
  function setMenu(header, open) {
    header.querySelector('.nav-l')?.classList.toggle('open', open);
    header.querySelector('[data-pr-menu-toggle]')?.setAttribute('aria-expanded', String(open));
  }
  document.addEventListener('keydown', e => {
    const header = e.target.closest('[data-pr-header]');
    if (header && e.key === 'Escape') { setMenu(header, false); header.querySelector('[data-pr-menu-toggle]')?.focus(); }
  });
  document.addEventListener('click', e => {
    document.querySelectorAll('[data-pr-header]').forEach(header => {
      const toggle = e.target.closest('[data-pr-menu-toggle]');
      if (toggle && header.contains(toggle)) setMenu(header, toggle.getAttribute('aria-expanded') !== 'true');
      else if (!header.contains(e.target) || e.target.closest('.nav-l a')) setMenu(header, false);
    });
    const anchor = e.target.closest('a[href^="#"]');
    if (!anchor) return;
    const href = anchor.getAttribute('href');
    if (href === '#') { e.preventDefault(); return; }
    const target = document.getElementById(href.slice(1));
    if (target) { e.preventDefault(); target.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion:reduce)').matches ? 'auto' : 'smooth' }); }
    else if (window.PR?.routes?.root) { e.preventDefault(); window.location.assign(window.PR.routes.root + href); }
  });
  document.addEventListener('shopify:section:load', e => init(e.target));
  init();
})();
